/**
 * Normas — GEN-PX-015 / 015b. Botón del raíl (grupo Saber · Normas). Abre DIRECTAMENTE el visor del mecanismo que emite
 * el kernel (ítems `mecanismo:*` del menú, solo al administrador, R-PT-02): su lista de normas y la ficha de cada una con
 * sus acciones. Con un solo mecanismo no hay paso intermedio; con varios, pestañas arriba, una por
 * mecanismo, con la primera abierta. Sin llamada nueva ni nombrar ningún mecanismo. Ocultar es cosmético (R-PT-04).
 */
import { useState } from 'react'
import { useSession } from '../context/SessionContext.jsx'
import { useFotoAgente } from '../context/FotosAgentes.jsx'
import CabeceraLanding from './CabeceraLanding.jsx'
import { Pestanas } from '../despacho/ui.jsx'
import MechanismViewer from '../mecanismos/MechanismViewer.jsx'
import { PREFIJO_MECANISMO } from '../mecanismos/registro.js'

/** Mecanismos del menú del kernel, visibles y habilitados. */
export function normasDelMenu(menu = []) {
  return menu.filter(m => m && m.visible && m.enabled && String(m.id).startsWith(PREFIJO_MECANISMO))
}

// GEN-PX-026: la cifra de la cabecera («N normas propuestas…») abre el listado filtrado por ese estado, donde se aprueban.
const FILTRO_DE_SECCION = { propuestas: { estado: 'propuesto' } }

export default function NormasPanel() {
  const { capabilities, agents = [] } = useSession()
  const fotoDe = useFotoAgente()
  const normas = normasDelMenu(capabilities?.menu)
  const [elegida, setElegida] = useState(null)
  const [filtros, setFiltros] = useState({ clave: 0, valores: {} })
  if (normas.length === 0) return <section className="dk-normas" aria-label="Normas"><p className="dk-meta">No hay normas disponibles.</p></section>
  const activa = normas.find(m => m.id === elegida) ?? normas[0]
  // Cabecera de Anne que emite el kernel en el ítem del mecanismo; aquí solo se pinta.
  const cab = activa.cabecera
  const ag = cab?.agente && (agents.find(a => a.id === cab.agente.id) ?? cab.agente)
  const cifras = (cab?.cifras ?? []).filter(c => FILTRO_DE_SECCION[c.seccion])
    .map(c => ({ texto: c.texto, onClick: () => setFiltros(f => ({ clave: f.clave + 1, valores: FILTRO_DE_SECCION[c.seccion] })) }))
  return (
    <section className="dk-normas" aria-label="Normas">
      {cab && (
        <CabeceraLanding
          agente={ag ? { nombre: cab.agente.nombre, rol: cab.agente.rol, foto: fotoDe(ag) } : null}
          titulo={cab.titulo}
          texto={cab.texto}
          cifras={cifras}
        />
      )}
      {normas.length > 1 && (
        <Pestanas
          etiqueta="Normas"
          pestanas={normas.map(m => ({ id: m.id, texto: m.label }))}
          activa={activa.id}
          onCambio={setElegida}
        />
      )}
      {/* `key`: cada mecanismo monta su visor desde cero (filtros, ficha abierta y acción en curso no se mezclan). */}
      <MechanismViewer key={`${activa.id}:${filtros.clave}`} viewId={activa.id} filtrosIniciales={filtros.valores} />
    </section>
  )
}
